module.exports = __webpack_public_path__ + "img/zip.13b0a5ec.png";